/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Templates_HintInputs */

const en_us2_coaching_templates_hint = /** @type {(inputs: Coaching_Templates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A template keeps only the structure: exercises, sets and progression. No name, no history.`)
};

const pt_br2_coaching_templates_hint = /** @type {(inputs: Coaching_Templates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um modelo guarda só a estrutura: exercícios, séries e progressão. Sem nome, sem histórico.`)
};

const pt_pt2_coaching_templates_hint = /** @type {(inputs: Coaching_Templates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um modelo guarda só a estrutura: exercícios, séries e progressão. Sem nome, sem histórico.`)
};

/** @type {(inputs: Coaching_Templates_HintInputs) => LocalizedString} */
const es_419_coaching_templates_hint = en_us2_coaching_templates_hint;

/** @type {(inputs: Coaching_Templates_HintInputs) => LocalizedString} */
const fr_fr2_coaching_templates_hint = en_us2_coaching_templates_hint;

/** @type {(inputs: Coaching_Templates_HintInputs) => LocalizedString} */
const de_de2_coaching_templates_hint = en_us2_coaching_templates_hint;

/** @type {(inputs: Coaching_Templates_HintInputs) => LocalizedString} */
const it_it2_coaching_templates_hint = en_us2_coaching_templates_hint;

/**
* | output |
* | --- |
* | "A template keeps only the structure: exercises, sets and progression. No name, no history." |
*
* @param {Coaching_Templates_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_templates_hint = /** @type {((inputs?: Coaching_Templates_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Templates_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_templates_hint(inputs)
	if (locale === "es-419") return es_419_coaching_templates_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_templates_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_templates_hint(inputs)
	if (locale === "de-DE") return de_de2_coaching_templates_hint(inputs)
	if (locale === "it-IT") return it_it2_coaching_templates_hint(inputs)
	return en_us2_coaching_templates_hint(inputs)
});
export { coaching_templates_hint as "coaching.templates_hint" }